module.exports = __webpack_public_path__ + "img/logo-md.ed5e99e6.png";